import { Component, inject, OnInit,Input } from '@angular/core';
import { Router } from '@angular/router';
import { Mdladdproduct } from '../../mdl-add-product/mdl-add.product';
import { MatDialog } from '@angular/material/dialog';
import { Api } from '../../../services/api';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { RouterLink } from '@angular/router';



@Component({
  selector: 'app-version-budget',
  imports: [CurrencyPipe, CommonModule, RouterLink],
  templateUrl: './budget-version.html',
  styleUrl: './budget-version.css'
})
export class BudgetVersion {
    @Input() presupuesto_id!: string;
    versiones: any[] = [];
    isLoading: boolean = true;
    errorMessage: string = '';

    constructor(private api: Api, private router:Router){}

    navigateToFullTable() {
    this.router.navigate(['/budget-version-table']);
  }



    


    ngOnInit(): void {
    if (this.presupuesto_id) {
      this.cargarVersiones();
    }
  }

  


cargarVersiones(): void {
    this.api.getBudgetVersions({ presupuesto_id: this.presupuesto_id }).subscribe({
        next: (response: any) => {
            this.versiones = response.versiones || [];
            this.isLoading = false;
            console.log('Versiones cargadas:', this.versiones);
        },
        error: (error) => {
            console.error('Error al cargar versiones:', error);
            this.errorMessage = 'Error al cargar las versiones. Por favor, inténtelo de nuevo más tarde.';
            this.isLoading = false;
        }})};













} 